<template>
  <div class="animated fadeIn">
    <h1 class="title">Integración con Trainingym</h1>
    <b-row
      ><b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
            <i class="icon-link"></i> Integrar con Trainingym
          </b-card-header>
          <b-card-body>
            <pulse-loader
              v-if="loading"
              :loading="loading"
              color="white"
              size="10px"
            ></pulse-loader>

            <div v-else-if="!trainingymUser">
              <p class="mb-2">
                Sincroniza todos tus entrenamientos con Trainingym de forma
                automática. Para empezar, solo tienes que vincular tu usuario
                con MyBodytone accediendo a tu cuenta de Trainigym:
              </p>
              <div class="content starting">
                <div class="login boxLogin" style="margin-top:3%">
                  <b-row>
                    <b-col class="box" lg="12" style="margin-top:20px">
                      <img
                        src="../assets/Trainingym_logo_003.svg"
                        alt="Bodytone"
                      />
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="12">
                      <h3>{{ $t("messages.signin") }}</h3>
                      <div class="form-group">
                        <b-form-input
                          type="text"
                          v-bind:placeholder="$t('messages.placeholder.email')"
                          v-model="email"
                        ></b-form-input>
                      </div>
                      <div class="form-group">
                        <b-form-input
                          type="password"
                          v-bind:placeholder="
                            $t('messages.placeholder.password')
                          "
                          v-model="password"
                        ></b-form-input>
                      </div>

                      <button class="enter" v-on:click="signIn">
                        {{ $t("messages.enter") }}
                      </button>
                      <hr />
                    </b-col>
                  </b-row>
                </div>
              </div>
            </div>
            <div v-else>
              <p class="mb-2">
                Sincronización con Traningym activada correctamente. Tus
                sesiones se sincronizarán automáticamente a partir de ahora.
              </p>
              <b-button variant="danger" v-on:click="deleteTrainingymUser"
                >Desvincular cuenta</b-button
              >
            </div>
          </b-card-body>
        </b-card></b-col
      ></b-row
    >
  </div>
</template>

<script>
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import VueNotifications from "vue-notifications";
export default {
  name: "Trainingym",
  components: {
    PulseLoader,
  },
  data() {
    return {
      //need to extract client_id, redirect_uri and scope to a constants file

      trainingymUser: false,
      loading: true,
      email: "",
      password: "",
    };
  },
  async mounted() {
    await this.getUserTrainingymInfo();

    this.loading = false;

   
  },
  methods: {
    async getUserTrainingymInfo() {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch("getUserTrainingymInfo")
          .then((response) => {
            this.trainingymUser = response;

            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    signIn: function () {
      this.loading = true;
      this.$store
        .dispatch("savetrainingymtokens", {
          trainingymauth: Object.assign(
            {},
            { email: this.email, password: this.password }
          ),
        })
        .then(
          (response) => {
            this.trainingymUser = true;
            this.loading = false;
            this.showSuccessMsg();
          },
          (error) => {
            this.showErrorMsg({message: "Credenciales incorrectas"});
            this.loading = false;
          }
        )
        .catch((err) => {
          this.loading = false;
          //TODO show message the credentials are not valid
        });
    },
    deleteTrainingymUser() {
      this.loading = true;

      return new Promise((resolve, reject) => {
        this.$store
          .dispatch("deleteTrainingymTokens")
          .then((response) => {
            this.trainingymUser = false;
            this.loading = false;

            resolve(response);
          })
          .catch((err) => {
            this.loading = false;

            reject(err);
          });
      });
    },
  },
  notifications: {
    showErrorMsg: {
      title: "Operation Failed",
      message: "Failed to authenticate",
      type: "error",
    },
    showSuccessMsg: {
      title: "Signin",
      message: "Operation success",
      type: "success",
      duration: 8000,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Trainingym.vue